import { atom } from "@mongez/react-atom";
import { OrderOptions } from "../types";

export const orderOptionsAtom: any = atom<OrderOptions>({
  key: "order-options",
  default: {},
});
